// globalThis polyfill for shell microfrontend
// This will be shared with other microfrontends

(function () {
  if (typeof globalThis === "object") return;

  Object.defineProperty(Object.prototype, "__magic__", {
    get: function () {
      return this;
    },
    configurable: true,
  });

  __magic__.globalThis = __magic__;
  delete Object.prototype.__magic__;
})();

// Fallback for environments that don't support Object.defineProperty
if (typeof globalThis === "undefined") {
  if (typeof self !== "undefined") {
    self.globalThis = self;
  } else if (typeof window !== "undefined") {
    window.globalThis = window;
  } else if (typeof global !== "undefined") {
    global.globalThis = global;
  } else {
    this.globalThis = this;
  }
}
